export const INFORMATION_SCREEN = 'information-screen';
export const YES_NO_QUESTION_TYPE = 'yes-no';
export const MULTIPLE_CHOICE_QUESTION_TYPE = 'multiple-choice';
export const MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE = 'multiple-choice-with-additional-answers';
export const GATED_MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE = 'gated-multiple-choice-with-additional-answers';
export const MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE =
    'multiple-choice-with-title-and-text-with-additional-answers';
export const TEXT_ANSWER_QUESTION_TYPE = 'text-answer';
export const GATED_TEXT_ANSWER_QUESTION_TYPE = 'gated-text-answer';
